import { IonContent, IonInput, IonPage, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Select from 'react-select';
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import DatePicker from "react-date-picker";
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const EffortUtilize: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [id] = useState(localStorage.getItem("SignupEmpId"))
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [projectId, setProjectId] = useState("");
    const [monthName, setMonthName] = useState("")
    const [month, setMonth] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [project, setProject] = useState([]);
    const [business, setBusiness] = useState("");
    const [businesslabel, setBusinesslabel] = useState("")
    const [departmentlabel, setdepartmentlabel] = useState("")
    const [department, setDeapartment] = useState("");
    const [businessUnitArr, setBusinessUnitArr] = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [showtable, setshowtable] = useState(false);
    //----------------Project Autocomplete------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [statusId, setStatusId] = useState('')
    const [projectStatusId, setProjectStatusId] = useState("")
    const [statusList, setStatusList] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [employeeid, setemployeeid] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const [noDataFound, setNoDataFound] = useState(false);

    const handleRowSelected = (state: any) => {
        const selectedIds = state.selectedRows.map((row: any) => row.id);
        console.log(selectedIds);
        setSelectedRows(selectedIds)
    };
    const isButtonDisabled = selectedRows.length === 0 || month === null;
    const dataArray = Array.isArray(data) ? data : [data];
    dataArray.forEach((item: any, index: any) => {
        item.serial = index + 1;
    });
    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    useEffect(() => {
        LoadEmployee();
    }, []);
    const LoadEmployee = () => {
        setIsLoading(true);
        service.HRViewEmployee()
            .then((response) => {
                console.log(response);
                console.log("Employee List", response.data.Data);

                setData(response.data.Data);
                setNoDataFound(!response.data.Data || response.data.Data.length === 0);

                ViewAllBusinessunit();
            })
            .catch((error) => {
                swal(error);
                setNoDataFound(true);
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            });
    };
    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)

                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

    const ViewAllDepartmentunit = (id: any) => {
        setDeapartment("");
        service.GetAllDepartmentUnitDropDown(id)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }
    const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentInputValue, setDepartmentInputValue] = useState('');
    const [departmentIsFocused, setDepartmentIsFocused] = useState(false);
    const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);
    const back = () => {
        history.goBack();
    }
    const handleDepartmentInputChange = (inputValue: any) => {
        setDepartmentInputValue(inputValue);
    };

    const handleDepartmentMenuOpen = () => {
        setDepartmentMenuIsOpen(true);
    };

    const handleDepartmentMenuClose = () => {
        setDepartmentMenuIsOpen(false);
    };

    const handleDepartmentFocus = () => {
        setDepartmentIsFocused(true);
    };

    const handleDepartmentBlur = () => {
        setDepartmentIsFocused(false);
    };

    const departmentOptions = [
        ...departmentUnitArr.map((state: any) => ({
            value: state.id,
            label: state.departmentName,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const [status, setstatus] = useState('');
    const optionss = [
        { value: '1', label: 'Active' },
        { value: '2', label: 'Inactive' },
    ]
    const handleDepartmentUnitChange = (selectedOption: any) => {
        setDeapartment(selectedOption.value);
        setdepartmentlabel(selectedOption.label)
    };
    const handlestatusChange = (selectedOption1: any) => {
        setstatus(selectedOption1.value)
    }
    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const options = [
        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),
        {
            value: 'all',
            label: 'All', 
        },
    ];
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);
    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };
    const Placeholders = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Status</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const handleprojectUnitChange = (selectedOption: any) => {
        setProjectId(selectedOption.value);
    };

    const DepartmentPlaceholder = () => {
        if (
            departmentInputValue === '' &&
            !selectedDepartment &&
            !departmentIsFocused
        ) {
            return <span style={{ color: "black" }}>Select Department Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DepartmentDropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);
        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    //.................Project Status Autocomplete........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Open</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options9 = statusList.map((state: any) => ({
        value: state.id,
        label: state.status,
    }));

    const hanldeStatusTypes = (selectedOption9: any) => {
        setProjectStatusId(selectedOption9.value);
    }

    const handleBusinessUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setBusiness(selectedOption.value);
        setBusinesslabel(selectedOption.label);
        // ViewAllDepartmentunit(selectedOption.value);
        if (selectedOption.value === 'all') {
            setDepartmentUnitArr([]);
            setDeapartment(""); 
        } else {
            ViewAllDepartmentunit(selectedOption.value);
        }
    };
    //-------------Getall Project Dropdown---------------//

    useEffect(() => {
        LoadProject();
        GetStatusList();
    }, []);

    const LoadProject = () => {
        service.GetallProject(id, projectStatusId)
            .then((response) => {
                console.log(response, "project")
                if (response.data.status === "200") {
                    setProject(response.data.Data);
                }
                else {
                    setProject([]);
                }
            })
    }

    // Month validation function
    const validateMonth = (selectedDate: Date): boolean => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // January is 0
        
        const selectedYear = selectedDate.getFullYear();
        const selectedMonth = selectedDate.getMonth() + 1;

        // Check if selected month is in the future
        if (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth > currentMonth)) {
            swal({
                title: "Invalid Month Selection",
                text: "You cannot select a future month. Please select current or past months only.",
                icon: "warning",
                buttons: {
                    ok: "OK"
                }
            } as any);
            return false;
        }

        // Check if selected month is before September 2024 (your existing validation)
        const minYear = 2024;
        const minMonth = 9; // September
        
        if (selectedYear < minYear || (selectedYear === minYear && selectedMonth < minMonth)) {
            swal({
                title: "Invalid Month Selection",
                text: "Please select only from September 2024 onwards. There is no data available for months before September 2024.",
                icon: "warning",
                buttons: {
                    ok: "OK"
                }
            } as any);
            return false;
        }

        return true;
    };

    const Empsort = () => {
        if (!month) {
            swal({
                title: "Month Required",
                text: "Please select a month and year to search.",
                icon: "warning",
                buttons: {
                    ok: "OK"
                }
            } as any);
            return;
        }

        // Validate the selected month
        if (!validateMonth(new Date(month))) {
            setMonth(null);
            setFromDate("");
            setToDate("");
            setMonthName("");
            setshowtable(false);
            setNoDataFound(false);
            return;
        }

        setIsLoading(true);
        setNoDataFound(false);
        const businessParam = business === 'all' ? '' : business;
        const departmentParam = department === 'all' ? '' : department;

        service.EffortUtilize(createdBy, businessParam, departmentParam, status)
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    const responseData = response.data.Data;
                    if (responseData !== null && responseData !== undefined && responseData.length > 0) {
                        setData(responseData);
                        setshowtable(true);
                        setNoDataFound(false);
                    } else {
                        setData([]);
                        setshowtable(false);
                        setNoDataFound(true);
                    }
                } else {
                    setData([]);
                    setshowtable(false);
                    setNoDataFound(true);
                }
            })
            .catch((error) => {
                swal(error);
                setData([]);
                setshowtable(false);
                setNoDataFound(true);
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            });
    };

    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }

    useEffect(() => {
        LoadProject();
    }, [projectStatusId]);

    //------------------Month(First and Last date)--------------------//

    const getMonth = (e: any) => {
        console.log(e, "dsvm")

        if (e) {
            // Validate the selected month first
            if (!validateMonth(new Date(e))) {
                setMonth(null);
                setFromDate("");
                setToDate("");
                setMonthName("");
                setshowtable(false);
                return;
            }

            setMonth(e)
            const selectedDate = new Date(e);
            const selectedMonth = selectedDate.getMonth() + 1;
            const selectedYear = selectedDate.getFullYear();

            const formattedDate = moment(e).format("YYYY-MM");
            let date: any = formattedDate.split('-');

            let year = date[0];
            let month = date[1];
            let startDate = moment([year, month - 1])
            let endDate = moment(startDate).endOf('month');

            var dates = [];
            let weeks = [];

            var per_week = [];
            var difference = endDate.diff(startDate, 'days');

            per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
            let index = 0;
            let last_week = false;

            while (startDate.add(1, 'days').diff(endDate) < 0) {
                if (startDate.day() != 0) {
                    per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
                }
                else {
                    if ((startDate.clone().add(7, 'days').month() == (month - 1))) {
                        weeks.push(per_week)
                        per_week = []
                        per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
                    }
                    else if (Math.abs(index - difference) > 0) {
                        if (!last_week) {
                            weeks.push(per_week);
                            per_week = [];
                        }
                        last_week = true;
                        per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"));
                    }
                }
                index += 1;
                if ((last_week == true && Math.abs(index - difference) == 0) ||
                    (Math.abs(index - difference) == 0 && per_week.length == 1)) {
                    weeks.push(per_week)
                }
                dates.push(startDate.clone().toDate());
            }

            let week1 = weeks.join()
            let days = (week1).split(',');
            let fDate: any;
            let tDate: any;
            if (days.length <= 1) {
                fDate = days[0]
                tDate = days.pop()
            }
            else if (days.length > 1) {
                fDate = days[0];
                tDate = days.pop();
            }

            setFromDate(fDate);
            setToDate(tDate);

            console.log(fDate, "km");
            console.log(tDate, "lm");

            const d = new Date();
            d.setMonth(month - 1);
            const monthName1 = d.toLocaleString("default", { month: "long" });
            console.log(monthName1, "month");
            setMonthName(monthName1);
        }

    }

    const Downloadpdf = async () => {
        try {
            const businessLabelForPdf = business === 'all' ? 'All Business Units' : businesslabel;
            const departmentLabelForPdf = department === 'all' ? 'All Departments' : departmentlabel;

            const response = await service.EffortUtilizereport(
                fromDate,
                toDate,
                selectedRows,
                businessLabelForPdf,
                departmentLabelForPdf
            );

            if (!response || !response.status) {
                swal('No data found or unexpected response.');
                return;
            }

            const status = Number(response.status);
            console.log(status, 'Response Status');

            if (status === 200) {
                console.log('PDF generated and downloaded successfully.');
            } else if (status === 204) {
                swal("", "No records", "error");
            } else {
                swal('No data found or unexpected response.');
            }
        } catch (error: any) {
            swal('An unexpected error occurred: ' + error.message);
        }
    };

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit?.businessUnitName || null,
            sortable: true,
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment?.departmentName || null,
            sortable: true,
        },

        {
            name: "Employee Name",
            sortable: true,
            width: "250px",
            cell: (itm: any) => (
                <>
                    <div>{itm.name}{" ("}{itm.employeeCode}{")"}</div>
                </>
            )
        },

        {
            name: "Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <IonText className={itm.statusFlag === true ? "color_approve" : "color_deny"}>
                        {itm.statusFlag === true ? "Active" : "Inactive"}
                    </IonText>
                </>
            )
        }
    ];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        },
        noData: {
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
            }
        }
    };

    const datatable = Array.isArray(data)
        ? data.filter((item: any) =>
            JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
        )
        : [];

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )
    }, [filterText, resetPaginationToggle]);

    const NoDataComponent = () => {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <IonText style={{ fontSize: '18px', color: '#666' }}>
                    No data available
                </IonText>
            </div>
        );
    };

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Effort Utilization Report</h3>
                                </div>
                            </div>
                            {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10500
                                    }}
                                >
                                    <div>
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div>
                                    <form className="row addmore">
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}>
                                                Business Unit<span className="text-danger">*</span>
                                            </label>
                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === business) || null}
                                                    onChange={handleBusinessUnitChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}>Department Unit <span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={departmentOptions}
                                                    value={departmentOptions.find((option) => option.value === department) || null}
                                                    onChange={handleDepartmentUnitChange}
                                                    onInputChange={handleDepartmentInputChange}
                                                    onMenuOpen={handleDepartmentMenuOpen}
                                                    onMenuClose={handleDepartmentMenuClose}
                                                    onFocus={handleDepartmentFocus}
                                                    onBlur={handleDepartmentBlur}
                                                    menuIsOpen={departmentMenuIsOpen}
                                                    isSearchable
                                                    placeholder={<DepartmentPlaceholder />}
                                                    components={{
                                                        DropdownIndicator: DepartmentDropdownIndicator,
                                                    }}
                                                    className="custom-select"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Month & Year <span className="text-danger">*</span></label>
                                                <div>
                                                    <DatePicker 
                                                        clearIcon={null} 
                                                        maxDetail="year" 
                                                        format="MM/yyyy" 
                                                        value={month} 
                                                        className="form-control" 
                                                        onChange={getMonth} 
                                                        maxDate={new Date()} // Prevents selecting future dates
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                            <a onClick={() => Empsort()} className="btn btn-success btn-block w-100"> Search </a>
                                        </div>
                                    </form>
                                </div>

                                <div style={{ marginTop: "5px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                                    {showtable && (
                                        <div className="col-sm-6 col-md-3">
                                            <a
                                                className={`btn btn-success btn-block w-100 ${isButtonDisabled ? "disabled" : ""}`}
                                                onClick={Downloadpdf}
                                                style={isButtonDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                            >
                                                Download PDF
                                            </a>
                                        </div>
                                    )}
                                </div>

                                {showtable && (
                                    <div style={{ marginTop: "15px" }} className="table-responsive">
                                        <DataTable
                                            columns={columns}
                                            data={datatable}
                                            pagination
                                            paginationPerPage={10}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            subHeader
                                            subHeaderComponent={subHeaderComponent}
                                            customStyles={customStyles}
                                            selectableRows
                                            onSelectedRowsChange={handleRowSelected}
                                            noDataComponent={<NoDataComponent />}
                                        />
                                    </div>
                                )}
                                {noDataFound && !isLoading && (
                                    <div style={{ textAlign: 'center', padding: '40px', marginTop: '20px' }}>
                                        <IonText style={{ fontSize: '18px', color: '#666' }}>
                                            No data found !
                                        </IonText>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default EffortUtilize;